import { useNavigate } from "react-router-dom";
import SVG from "../../SVG";
import { Tooltip } from "react-tooltip";
import { API_BASE_URL } from "../../../config/api";
import { useState } from "react";
import { Spinner } from "../../AsyncState";

const ADMIN_LOGOUT_ENDPOINT = `${API_BASE_URL}/api/v0/auth/admin/logout/`;

export default function Quit() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    if (loading) return;
    setLoading(true);
    const refresh = localStorage.getItem("refresh");

    try {
      if (refresh) {
        await fetch(ADMIN_LOGOUT_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refresh }),
        });
      }
    } finally {
      localStorage.removeItem("email");
      localStorage.removeItem("refresh");
      localStorage.removeItem("access");
      localStorage.removeItem("role");
      navigate("/SignIn", { replace: true });
    }
  };

  return (
    <>
      <button
        type="button"
        className="outline-none"
        data-tooltip-id="quitTooltip"
        data-tooltip-content="خروج"
        onClick={handleLogout}
        disabled={loading}
        aria-busy={loading}
      >
        {loading ? <Spinner size={20} stroke={3} color="currentColor" /> : <SVG name="quit" classname="size-5 drop-shadow-md cursor-pointer" />}
      </button>

      <Tooltip
        id="quitTooltip"
        place="bottom"
        className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-zi-blue-dark !rounded-lg"
      />
    </>
  );
}
